import type { TranslationMessages } from '../../types';

export const common: TranslationMessages = {
  add: 'Add',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Information',
  retry: 'Retry',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  import: 'Import',
  refresh: 'Refresh',
  settings: 'Settings',
  help: 'Help',
  support: 'Support',
  logout: 'Logout',
  profile: 'Profile',
  dashboard: 'Dashboard',
  notifications: 'Notifications',
  messages: 'Messages',
  no_data: 'No data available',
  no_results: 'No results found',
  try_again: 'Try again',
  something_went_wrong: 'Something went wrong',
  please_try_again: 'Please try again',
  access_denied: 'Access denied',
  insufficient_permissions: 'Insufficient permissions',
  validation_error: 'Validation error',
  network_error: 'Network error',
  server_error: 'Server error',
  timeout_error: 'Request timeout',
  mobile_optimized: 'Mobile Optimized',
  touch_friendly: 'Touch Friendly',
  responsive_design: 'Responsive Design',
  staff: 'Staff',
  dates: 'Dates',
  status: 'Status',
  actions: 'Actions',
  reason: 'Reason',
  submit: 'Submit',
  start_date: 'Start Date',
  end_date: 'End Date',
  confirm_delete: 'Are you sure you want to delete this?',
};
